import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  SchoolDayDetailsView,
  timetableSettingsQueryOptions
} from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/school-settings/day/')({
  component: SchoolDayDetailsView,
  loader: async ({ context }) =>
    context.queryClient.ensureQueryData(timetableSettingsQueryOptions),
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.school-settings', { ns: 'schoolSettings' }),
      i18n.t('title.school-day', { ns: 'schoolSettings' })
    ])
})
